<template>
  <div>
    <div
      v-show="firstModal"
      class="title-sign-in">
      <carousel
        :per-page="1"
        :loop="true"
        :autoplay="true"
        pagination-active-color="#DE3745"
        pagination-color="#CCCCCC">
        <slide
          v-for="(item, index) in images"
          :key="index"
          class="slide-create-account">
          <img
            :src="item.nameImage"
            class="img-slide"
            width="160"
            height="180">
          <h1>{{ item.title }}</h1>
          <p>{{ item.paragraph }} <a href="#">{{ item.link }}</a></p>
        </slide>
      </carousel>
      <div class="btns-create-account">
        <el-button
          class="btn-facebook"
          disabled="true">Crear cuenta con Facebook</el-button>
        <el-button
          type="text"
          class="btn-create-account"
          @click="toSecondModal">Crear cuenta con email
        </el-button>
      </div>
    </div>
    <!-- SECOND MODAL-->
    <div
      v-loading.fullscreen.lock="fullscreenLoading"
      v-show="secondModal"
      class="second-modal">
      <div class="logo">
        <img
          width="60"
          height="80"
          src="@/assets/images/secure-login.svg"
          alt="logo-secure-login">
        <h1>Crea cuenta</h1>
        <p>Al crear tu cuenta aceptas los <br>
          <a href="">Términos y condiciones</a>
        </p>
      </div>
      <el-form
        ref="formRegister"
        :model="model"
        :rules="rules"
        @submit.native.prevent="onSubmit">
        <el-form-item prop="email">
          <el-input
            v-model="model.email"
            type="email"
            placeholder="Email"
            prefix-icon="icon-mail-icon"/>
        </el-form-item>
        <el-form-item prop="firstName">
          <el-input
            v-model="model.firstName"
            type="text"
            placeholder="Nombre"
            prefix-icon="icon-user-icon"/>
        </el-form-item>
        <el-form-item prop="lastName">
          <el-input
            v-model="model.lastName"
            type="text"
            placeholder="Apellido"
            prefix-icon="icon-user-icon"/>
        </el-form-item>
        <el-form-item prop="zipCode">
          <el-input
            v-model="model.zipCode"
            type="number"
            placeholder="Código postal"
            prefix-icon="icon-user-icon"/>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            id="registerPassword"
            v-model="model.password"
            type="password"
            prefix-icon="icon-key-icon"
            placeholder="Contraseña">
            <i
              slot="suffix"
              class="icon-eye-icon showPassword"
              @click="showPassword"/>
          </el-input>
        </el-form-item>
        <div class="btn-register">
          <el-button
            type="primary"
            native-type="submit"
            class="btn-create-account">Crear cuenta
          </el-button>
          <!--<a >Crear cuenta con Facebook</a>-->
        </div>
      </el-form>
    </div>
    <!-- THIRD MODAL-->
    <div
      v-show="thirdModal"
      class="third-modal">
      <div class="logo-email">
        <img
          width="157"
          height="157"
          src="@/assets/images/card.svg"
          alt="logo-reset-password">
      </div>
      <div class="info-email">
        <h1>Activa tu cuenta</h1>
        <h2>Te hemos enviado un correo <br> para activar tu cuenta.</h2>
        <p>El correo pudo haber sido guardado en <br> la carpeta de correo no deseado.</p>
        <el-button
          class="accept"
          @click="goToHome">Aceptar
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AuthRegisterModel from '@/models/auth-register.model'
import http from '@/services/http.service'
// import auth from '@/services/auth.service'
// import httpErrorNotification from '@/services/http-error-notification.service'
export default {
  name: 'AuthRegister',
  data () {
    return {
      fullscreenLoading: false,
      hide: true,
      /// ///////
      firstModal: true,
      secondModal: false,
      thirdModal: false,
      /// ///////
      model: AuthRegisterModel.model(),
      rules: AuthRegisterModel.rules(),
      images: [
        {
          nameImage: '/static/images/slide-create-account/shield-secure.svg',
          title: '¡Tus datos seguros!',
          paragraph: 'No te preocupes, todos los datos que nos brindes están ' +
          'protegidos. Si quieres saber cómo, visita nuestra',
          link: 'Declaración de la privacidad.'
        },
        {
          nameImage: '/static/images/slide-create-account/tickets-signup-icon.svg',
          title: '¡Disfruta de los mejores eventos!',
          paragraph: 'No esperes más para tener tu cuenta y obtén el acceso a los ' +
          'mejores eventos. \n'

        },
        {
          nameImage: '/static/images/slide-create-account/micro-signup-icon.svg',
          title: '¡Invita a quien quieras!',
          paragraph: 'Utiliza nuestro buscador para encontrar tu evento rápido e ' +
          'invita a tus amigos compartiendo el evento.'
        }
      ]
    }
  },
  mounted () {
    if (this.$route.name === 'verify-account') {
      this.$router.push('Home')
    }
    if (this.$route.name === 'register') {
      this.firstModal = false
      this.secondModal = true
    }
  },
  methods: {
    toSecondModal () {
      this.firstModal = false
      this.secondModal = true
    },
    goToHome () {
      this.thirdModal = false
      this.$router.push({name: 'Home'})
    },
    showPassword () {
      let inputPassword = document.getElementById('registerPassword')
      if (inputPassword.type === 'password') {
        inputPassword.type = 'text'
      } else {
        inputPassword.type = 'password'
      }
    },
    /// ////CREATE ACCOUNT//////
    onSubmit (e) {
      this.$refs.formRegister.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          http.post('https://dev-api.myticket.mx/api/v1/sing-up', this.model).then((response) => {
            this.$notify.success('Usuario creado con éxito')
          }).catch((e) => {

          }).finally(() => {
            this.secondModal = false
            this.thirdModal = true
            this.fullscreenLoading = false
            // this.$router.push('confirm-account')
          })
        } else {
          this.$notify.error({
            title: 'Verifica el formulario',
            message: 'Por favor revisa los errores que se indican'
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .overlay {
    height: 100vh;
    background-color: rgba(black, .5);
    .auth-box {
      width: 200px;
    }
  }

  .slide-create-account {
    text-align: center;
    h1{
      margin: 0;
      margin-bottom: 6px;
      @include font-primary(21px, semibold);
      color: $carbon;
    }
    p{
      margin: 0;
      @include font-primary(12px, regular);
      color: #777777;
    }
    .img-slide {
      margin-bottom: 34px;
    }
  }

  .btns-create-account {
    text-align: center;
    margin-top: 26px;
  }
  .btn-facebook{
    background-color: #47639E;
    display: none;
    color: white;
    width: 100%;
    border-radius: 2px;
    border: none;
    @include font-primary(12px, bold);
    margin-bottom: 19px;
    &:hover{
      background-color: #47639E;
      color: white;
    }
  }

  .btn-create-account{
    @include font-primary(12px, regular);
    color: $roseHeader;
    text-decoration: underline;
    height: 10px;
  }

  /////////////SECOND MODAL//////////
  .second-modal {
    .logo {
      text-align: center;
      h1 {
        @include font-primary(21px, semibold);
        color: $carbon;
        margin: 0;
      }
    }
    .btn-register {
      text-align: center;
      .btn-create-account {
        width: 100%;
        background-color: $roseHeader;
        color: white;
        border: none;
        text-decoration: none;
        padding: 0;
        height: 40px;
        border-radius: 2px;
        @include font-primary(12px, bold);
        margin-bottom: 30px;
      }
      a {
        @include font-primary(12px, regular);
        color: $roseHeader;
        text-decoration: underline;
      }
    }
  }
.showPassword{
  cursor: pointer;
  &:hover{
  color: black;
  }
}
  /////////////THIRD MODAL//////////
  .third-modal {
    .logo-email {
      text-align: center;
    }
    .info-email {
      text-align: center;
      margin-top: 35px;
      h1 {
        @include font-primary(21px, semibold);
        color: $carbon;
        margin: 0;
        margin-bottom: 18px;
      }
      h2 {
        @include font-primary(14px, regular);
        color: $carbon;
        margin: 0;
        margin-bottom: 12px;
      }
      p {
        @include font-primary(12px, regular);
        color: #777777
      }
      .accept {
        width: 100%;
        color: white;
        background-color: $roseHeader;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/auth-register.vue